import * as types from '../dashboardActionTypes';

export default function securityAlertsLastWeekLoadingReducer(state = true, action) {
    switch(action.type) {
        case types.LOAD_SECURITY_ALERTS_LAST_WEEK:
            return true;
        case types.LOAD_SECURITY_ALERTS_FOR_LAST_WEEK_FAILED:
        case types.LOAD_SECURITY_ALERTS_LAST_WEEK_SUCCESS:
            return false;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/dashboard/reducers/securityAlertsLastWeekLoadingReducer.js